import NepaliDate from 'nepali-date-converter';

// Centralized BS date formatting utility
export const formatToBSDate = (adDate) => {
  if (!adDate) return '';
  
  try {
    const date = new Date(adDate);
    if (isNaN(date.getTime())) return '';
    
    const nepaliDate = new NepaliDate(date);
    const year = nepaliDate.getYear();
    const month = (nepaliDate.getMonth() + 1).toString().padStart(2, '0');
    const day = nepaliDate.getDate().toString().padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error converting to BS date:', error);
    return '';
  }
};

export const formatToBSDisplay = (adDate) => {
  if (!adDate) return '';
  
  try {
    const date = new Date(adDate);
    if (isNaN(date.getTime())) return '';
    
    const nepaliDate = new NepaliDate(date);
    const year = nepaliDate.getYear();
    const month = nepaliDate.getMonth();
    const day = nepaliDate.getDate();
    
    const nepaliMonths = [
      'Baishakh', 'Jestha', 'Ashadh', 'Shrawan', 'Bhadra', 'Ashwin', 
      'Kartik', 'Mangsir', 'Poush', 'Magh', 'Falgun', 'Chaitra'
    ];
    
    return `${day} ${nepaliMonths[month]} ${year}`;
  } catch (error) {
    console.error('Error formatting BS display:', error);
    return '';
  }
};

export const formatToBSMonthYear = (adDate) => {
  if (!adDate) return '';
  
  try {
    const date = new Date(adDate);
    if (isNaN(date.getTime())) return '';
    
    const nepaliDate = new NepaliDate(date);
    const year = nepaliDate.getYear();
    const month = nepaliDate.getMonth();
    
    const nepaliMonths = [
      'Baishakh', 'Jestha', 'Ashadh', 'Shrawan', 'Bhadra', 'Ashwin', 
      'Kartik', 'Mangsir', 'Poush', 'Magh', 'Falgun', 'Chaitra'
    ];
    
    return `${nepaliMonths[month]} ${year}`;
  } catch (error) {
    console.error('Error formatting BS month/year:', error);
    return '';
  }
};

// Helper to convert AD string to BS display
export const convertAndFormatBS = (dateString) => {
  if (!dateString) return '';
  return formatToBSDisplay(dateString);
};

// Helper for table display
export const formatBSTableDate = (dateString) => {
  if (!dateString) return '-';
  return formatToBSDisplay(dateString);
};

// Helper to convert BS date to AD for form submissions
export const convertBSToAD = (bsDate) => {
  if (!bsDate) return '';
  
  try {
    const [year, month, day] = bsDate.split('-').map(Number);
    const nepaliDate = new NepaliDate(year, month - 1, day);
    const adDate = nepaliDate.toEnglishDate();
    return adDate.toISOString().split('T')[0];
  } catch (error) {
    console.error('Error converting BS to AD:', error);
    return '';
  }
};
